export default __webpack_public_path__ + "static/media/complementary--except-tractors--g2.b5eb0923.png";